export const REGIONS_DATA = [
    {
        id: 'global',
        name: 'Global',
        countries: [] // Will be populated below
    },
    {
        id: 'north-america',
        name: 'North America',
        countries: ['United States', 'Canada', 'Mexico', 'Antigua and Barbuda', 'Bahamas', 'Barbados', 'Belize', 'Costa Rica', 'Cuba', 'Dominica', 'Dominican Republic', 'El Salvador', 'Grenada', 'Guatemala', 'Haiti', 'Honduras', 'Jamaica', 'Nicaragua', 'Panama', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Trinidad and Tobago']
    },
    {
        id: 'latin-america',
        name: 'Latin America',
        countries: ['Brazil', 'Argentina', 'Chile', 'Colombia', 'Peru', 'Ecuador', 'Bolivia', 'Guyana', 'Paraguay', 'Suriname', 'Uruguay', 'Venezuela']
    },
    {
        id: 'europe',
        name: 'Europe',
        countries: ['United Kingdom', 'Germany', 'France', 'Italy', 'Spain', 'Netherlands', 'Switzerland', 'Sweden', 'Poland', 'Austria', 'Belgium', 'Norway', 'Denmark', 'Finland', 'Ireland', 'Greece', 'Portugal', 'Czech Republic', 'Hungary', 'Romania', 'Bulgaria', 'Slovakia', 'Croatia', 'Lithuania', 'Latvia', 'Estonia', 'Slovenia', 'Luxembourg', 'Cyprus', 'Malta', 'Iceland', 'Monaco', 'Liechtenstein', 'Andorra', 'San Marino', 'Vatican City', 'Ukraine', 'Belarus', 'Moldova', 'Russia', 'Turkey', 'Albania', 'Bosnia and Herzegovina', 'Montenegro', 'North Macedonia', 'Serbia']
    },
    {
        id: 'asia-pacific',
        name: 'Asia Pacific',
        countries: ['China', 'Japan', 'India', 'South Korea', 'Singapore', 'Thailand', 'Vietnam', 'Indonesia', 'Malaysia', 'Philippines', 'Taiwan', 'Afghanistan', 'Armenia', 'Azerbaijan', 'Bahrain', 'Bangladesh', 'Bhutan', 'Brunei', 'Cambodia', 'Georgia', 'Hong Kong', 'Iran', 'Iraq', 'Jordan', 'Kazakhstan', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Lebanon', 'Macau', 'Maldives', 'Mongolia', 'Myanmar', 'Nepal', 'Oman', 'Pakistan', 'Palestine', 'Qatar', 'Saudi Arabia', 'Sri Lanka', 'Syria', 'Tajikistan', 'Timor-Leste', 'Turkmenistan', 'United Arab Emirates', 'Uzbekistan', 'Yemen', 'Australia', 'New Zealand', 'Fiji', 'Papua New Guinea', 'Solomon Islands', 'Vanuatu', 'Samoa', 'Kiribati', 'Tonga', 'Micronesia', 'Marshall Islands', 'Palau', 'Tuvalu', 'Nauru']
    },
    {
        id: 'middle-east-africa',
        name: 'Middle East & Africa',
        countries: ['Saudi Arabia', 'United Arab Emirates', 'Israel', 'Turkey', 'Qatar', 'Kuwait', 'Egypt', 'Oman', 'Jordan', 'Bahrain', 'Iran', 'Iraq', 'Lebanon', 'Palestine', 'Syria', 'Yemen', 'South Africa', 'Nigeria', 'Kenya', 'Morocco', 'Algeria', 'Ethiopia', 'Ghana', 'Angola', 'Benin', 'Botswana', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cameroon', 'Central African Republic', 'Chad', 'Comoros', 'DR Congo', 'Republic of the Congo', 'Djibouti', 'Equatorial Guinea', 'Eritrea', 'Eswatini', 'Gabon', 'Gambia', 'Guinea', 'Guinea-Bissau', 'Ivory Coast', 'Lesotho', 'Liberia', 'Libya', 'Madagascar', 'Malawi', 'Mali', 'Mauritania', 'Mauritius', 'Mozambique', 'Namibia', 'Niger', 'Rwanda', 'Sao Tome and Principe', 'Senegal', 'Seychelles', 'Sierra Leone', 'Somalia', 'South Sudan', 'Sudan', 'Tanzania', 'Togo', 'Tunisia', 'Uganda', 'Zambia', 'Zimbabwe']
    }
];

// Helper to get all unique countries from all regions
export const getAllCountries = () => {
    const countries = REGIONS_DATA.reduce((acc, region) => {
        if (region.id === 'global') return acc;
        return [...acc, ...region.countries];
    }, []);
    return [...new Set(countries)].sort();
};

export const CURRENCIES = [
    { code: 'USD', symbol: '$', rate: 1, name: 'US Dollars' },
    { code: 'INR', symbol: '₹', rate: 83.5, name: 'Indian Rupees' },
    { code: 'JPY', symbol: '¥', rate: 150.2, name: 'Japanese Yen' },
    { code: 'EUR', symbol: '€', rate: 0.92, name: 'Euros' }
];


// Populating Global region
export const FULL_COUNTRIES_LIST = getAllCountries();

export const fetchCurrencies = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/currencies`);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        // Expect data.currencies array
        if (Array.isArray(data.currencies)) {
            return data.currencies;
        }
        return data;
    } catch (err) {
        console.warn('Failed to fetch currencies from API, falling back to static list', err);
        return CURRENCIES;
    }
};

